import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function inlineTableStyle({ $inlineTable = false }: ButtonStyleProps) {
  if ($inlineTable) {
    return css`
      min-width: 4rem;
      margin: 0.5rem 0;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      min-height: 2.16666rem;
    `;
  }
}
